
export * from '../../frontend-taglib-clay/__liferay__/exports/@clayui$multi-select.js';

import __default__ from '../../frontend-taglib-clay/__liferay__/exports/@clayui$multi-select.js';
export default __default__;
